import type {
    GA4CancellationPolicyType,
    GTMEcommerceReturnType,
    GTMItemData,
    GTMItemsReturnType
} from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';
import { calculateValue } from '../GTMHelpers';

interface GTMAddToCartEcommerceReturnType {
    items: GTMItemsReturnType[];
    value: number;
}

interface GTMDetailAddToCartButtonClickModelData extends GTMItemData {
    pricePerNight: number;
    quantity: number;
    cancellationPolicy: GA4CancellationPolicyType;
}

type GTMDetailAddToCartReturnType = GTMEcommerceReturnType<GTMAddToCartEcommerceReturnType>;

export default class GTMDetailAddToCartButtonClickModel extends GTMBaseModel {
    public static parseToGTMData({
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity,
        cancellationPolicy
    }: GTMDetailAddToCartButtonClickModelData): GTMDetailAddToCartReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'add_to_cart',
            ecommerce: {
                value: calculateValue(pricePerNight, quantity),
                items: [
                    {
                        index: 0,
                        item_id: id,
                        item_name: title,
                        item_category: country,
                        item_category2: region,
                        item_category3: department,
                        item_category4: place,
                        discount,
                        quantity,
                        price: pricePerNight,
                        instant_booking: instantBooking,
                        cancellation_policy: cancellationPolicy
                    }
                ]
            }
        };
    }
}
